<template>
  <div id="join">
    <rich-text v-if="page" :elements="page.document.content" :is-root="true"></rich-text>

    <section class="offers" v-if="jobs && modalVisible">
      <div class="container ads">
        <div class="columns">
          <div class="column is-4" v-for="(offer, index) in jobs" :key="`offer-${index}`">
            <button @click="modalVisible[offer.contentId] = true" :style="{ backgroundImage: `url(${getImage(offer.document.image)})`}">
              <h3 class="title">{{ offer.document.title }}</h3>
            </button>

            <b-modal class="modal" :active.sync="modalVisible[offer.contentId]">
              <div class="modal-background"></div>
              <div class="modal-content has-background-white">
                <div class="columns is-multiline is-mobile">
                  <div class="column is-12 modal-hero">
                    <figure>
                      <img :src="getImage(offer.document.image)" alt="">
                    </figure>
                  </div>
                  <div class="column is-10 is-offset-1 title">
                    <h3 class="title">{{ offer.document.title }}</h3>
                    <figure class="image is-3by1"></figure>
                  </div>
                  <div class="column is-10 is-offset-1 has-text-centered columns is-multiline">
                    <div class="column">
                        <figure class="image is-64x64 is-m-auto"><img :src="icons.experience" alt=""></figure>
                        <h4 class="title">{{ offer.document.type }}</h4>
                    </div>
                    <div class="column">
                        <figure class="image is-64x64 is-m-auto"><img :src="icons.diploma" alt=""></figure>
                        <h4 class="title">{{ offer.document.education }}</h4>
                    </div>
                    <div class="column">
                        <figure class="image is-64x64 is-m-auto"><img :src="icons.companies" alt=""></figure>
                        <h4 class="title">{{ offer.document.experience }}</h4>
                    </div>
                    <div class="column">
                        <figure class="image is-64x64 is-m-auto"><img :src="icons.mapmarkerplace" alt=""></figure>
                        <h4 class="title">{{ offer.document.location }}</h4>
                    </div>
                  </div>
                  <div class="column is-10 is-offset-1 has-text-centered">
                    <rich-text :elements="offer.document.content" :is-root="true"></rich-text>
                    <a target="_blank" class="button"
                      href="mailto:recrutement@guemas-associes.fr?subject=Candidature à une offre d’emploi">Postuler</a>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="testimonials">
      <div class="container">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-6">
            <h2 class="title">{{ testimonials.title }}</h2>
            <figure class="image is-3by1"></figure>
          </div>
          <div class="column"></div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-4"
          v-for="(testimonial, index) in testimonials.list" :key="`testimonial-${index}`">
            <div class="box">
              <figure class="image">
                <img :src="testimonial.image" alt="">
              </figure>
              <h4 class="title has-text-centered">{{ testimonial.name }}</h4>
              <figure class="image is-3by1"></figure>
              <p>{{ testimonial.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import api from '@/services/api';
import * as icons from '@/assets/icons';
import RichText from '@/components/RichText.vue';

export default {
  name: 'join',
  props: ['page'],
  components: {
    RichText,
  },
  data() {
    return {
      jobs: null,
      modalVisible: null,
      icons,
    };
  },
  async created() {
    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      this.jobs = await api.getJobs();
      const modalVisible = {};
      this.jobs.forEach((element) => {
        modalVisible[element.contentId] = false;
      });
      this.modalVisible = modalVisible;
    },
    getImage(source) {
      return api.getImage(source);
    },
  },
};
</script>

<style lang='sass'>
  #join
    .introduction
      position: relative
      margin-bottom: 5rem
      padding: 3rem 0 3.5rem
      background: linear-gradient(to right, white 0%, white 30%, #ecf1f4 30%, #ecf1f4 100%)
      .column:first-child
        text-align: right
      h2
        position: relative
        display: inline-block
        margin-right: 8rem
        &::after
          content: ""
          position: absolute
          right: 0
          bottom: -1rem
          display: block
          height: 4px
          width: 1500px
          background-color: #fe3904

  .modal
    .container
      width: auto
      text-align: left
    h3
      color: #fe3904 !important
    h4
      color: #0e6faa
      font-size: 1.2rem !important
      font-weight: 500 !important
      &.title
        margin-bottom: 0 !important
        font-size: 1.1rem !important
    .modal-content
      width: 100%
      border-radius: 2px
    .modal-hero
      padding: 0
      height: 120px
      overflow: hidden
      opacity: 0.4
    .title
      position: relative
      margin-top: 0.6rem !important
      margin-bottom: 1rem
      figure
        padding: 0
        margin: 1rem 0 0
        height: 4px
        width: 5%
        left: 0
        bottom: 0
        background-color: #fe3904
    img
      width: 100%
    button, .button
      border: 0
      color: #ffffff
      background-color: #fe3904
      text-transform: uppercase
    .button
      margin: 2rem auto

  .testimonials
    position: relative
    margin: 0 !important
    padding: 10rem 0
    background-color: #ecf1f4
    h2+figure
      padding: 0 !important
      margin: 1rem 0 3rem 0
      height: 4px
      width: 10%
      background-color: #fe3904
    .box
      padding: 0
      border-radius: 0
      box-shadow: none
      h4, p
        padding: 1rem
      h4
        font-weight: 600
        + figure
          margin: 0 auto
          padding: 0
          height: 4px
          width: 10%
          background-color: #fe3904

  .ads
    .columns
      .column
        > button
          position: relative
          display: flex
          width: 100%
          height: 400px
          padding: 0
          justify-content: center
          cursor: pointer
          background-size: cover
          h3
            position: absolute
            top: 40%
            width: 50%
            text-align: center
            color: #ffffff
            &::before
              position: absolute
              content: ""
              margin: -1rem 0 0 -1rem
              height: 20px
              width: 20px
              top: 0
              left: 0
              border-left: 3px solid #fe3904
              border-top: 3px solid #fe3904
            &::after
              position: absolute
              content: ""
              margin: 0 -1rem -1rem 0
              height: 20px
              width: 20px
              bottom: 0
              right: 0
              border-right: 3px solid #fe3904
              border-bottom: 3px solid #fe3904
      .ad-1
        cursor: pointer
</style>
